

export const YellowCircle = props => (
  <div
    className="bgYellow075 pos-rel border-rad50"
    style={{
      height: 6,
      width: 6,
      top: 10,
    }}
  />
);
